// Module
var code = `<div class="alert alert-info" ng-if="accountType === 'STAFF'"> <em class="fa fa-info-circle"></em> <span translate> As part of the new HR Hub, Cru Staff have been assigned a new Staff Account number, which differs from their Designation number (the Designation number stays the same). </span> </div> `;
// Exports
var _module_exports =code;;
var path = '/scripts/directives/staffAccountNotice/staffAccountNotice.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;